import React, { useEffect, useState } from 'react';
import CampaignCard from './CampaignCard'; // Adjust the import path
import { connect } from "react-redux";
import _ from "lodash";
import * as actionTypes from "../../../../store/actions/actionTypes";
import { boxiPrimary } from '../../../../assets/style/colors';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

function CampaignCardsContainer(props) {
  const userId = parseInt(props.userId || null)
  const [allTrucks, setAllTrucks] = useState([])
  const [loadingTrucks, setLoadingTrucks] = useState(false)
  useEffect(() => {
    getAllTrucks()
  }, [])
  const getAllTrucks = async () => {
    setLoadingTrucks(true)
    if(userId){
      let res1 = await axios.get(`${process.env.REACT_APP_API_HOST}/campaign/${userId}/trucks`, {
        withCredentials: true
      });
      if(res1?.data?.allCampaigntrucks?.length > 0) {
        setLoadingTrucks(false)
        setAllTrucks([...res1?.data?.allCampaigntrucks])
      } else {
        setLoadingTrucks(false)
        setAllTrucks([])
      }

    }
    
  }
  if (_.isEmpty(props.campaignsCards)) {
    return <>No Campaign Found</>;
  }

  const { selected, campaignsCards, onDropdownSelect, classes } = props;


  const changeCampaign = (campaign_id) =>{
    let path = window.location.pathname;
    if (path.endsWith("map"))
    props.history.push(`/dashboard/admin/advertise/client/impersonate/${props.match.params.client_id}/campaign/${campaign_id}/${path.endsWith("map")? 'map' : 'analytics'}`);

  }
  
  return (
    <div className={classes.campaign_cards_container}>
      {
        Object.entries(campaignsCards).map(([key, campaign], index) => {
          let campaignActiveTrucks = allTrucks.length > 0 ? (allTrucks.find(item => item.campaign_id == key)) : []
          return (
          <CampaignCard 
          loadingTrucks={loadingTrucks}
          key={key} 
          clientInpersonate={props.clientInpersonate}
          id={key}
          campaignActiveTrucks={campaignActiveTrucks}
          campaign={campaign} 
          click={() => {
            onDropdownSelect(key)
            if(props.clientInpersonate) {
              changeCampaign(key)
            }
          }} 
          classes={classes} 
          boxiPrimary={boxiPrimary} 
          active={true}
          selected={selected}
          index={index}
          />
        )})
      }
    </div>
  );
}


const mapStateToProps = (state) => {
  return {
    selected: state.clientDashboardTemp.selected,
    campaigns: state.clientDashboardTemp.campaigns,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onDropdownSelect: (id) =>
      dispatch({
        type: actionTypes.UPDATE_SELECTED_TEMP,
        selected: id
      })
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(CampaignCardsContainer);






